export default __webpack_public_path__ + "static/media/(14).27ca0e7d.jpeg";